import React from 'react';
import { Heart, ShieldCheck, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const BoardingPage = () => {
  const config = {
    badge: "Pet Boarding",
    headline: "Safe &",
    headlineItalic: "Comfortable Boarding.",
    subtext: "Veterinary-supervised boarding where your pet receives professional care, comfort, and love — a true home away from home.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Premium Pet Boarding at Dr. Suresh Pet Care — Safe Animal Boarding",
    stats: [
      { value: 2000, suffix: '+', label: 'Pets Boarded' },
      { value: 100, suffix: '%', label: 'Veterinary Supervised' },
      { value: 24, suffix: '/7', label: 'Constant Monitoring' },
      { value: 5, suffix: '★', label: 'Guest Rating' },
    ],
    services: [
      {
        title: "Medical Boarding",
        icon: <Activity size={28} />,
        desc: "Specialized boarding for pets requiring medication administration, wound care, or post-surgical monitoring.",
        specs: ["IV Fluid Management", "Medication Protocol", "Wound Care", "24-Hr Observation"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Luxury Pet Suites",
        icon: <Heart size={28} />,
        desc: "Comfortable, climate-controlled accommodation with dedicated activity time and enrichment programs.",
        specs: ["Climate Controlled", "Play Sessions", "Nutritious Meals", "Bedding & Comfort"],
        color: "from-primary/10 to-amber-500/10"
      },
      {
        title: "Health Monitoring",
        icon: <ShieldCheck size={28} />,
        desc: "Daily veterinary health checks, appetite monitoring, and immediate medical response if required.",
        specs: ["Daily Health Check", "Appetite Tracking", "Parasite Prevention", "Emergency Care"],
        color: "from-green-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Boarding",
    sectionItalic: "Services.",
    warningTitle: "Peace of Mind",
    warningItalic: "Guaranteed.",
    warningText: "Our boarding facility is managed by veterinary professionals, giving you complete confidence your pet is in safe, caring hands.",
    warnings: [
      { name: "Veterinary On-Site", desc: "A licensed veterinarian oversees boarding operations at all times.", icon: "👨‍⚕️" },
      { name: "Emergency Ready", desc: "In-house critical care capabilities provide immediate response to any health concern.", icon: "🚨" },
      { name: "Socialisation", desc: "Supervised socialization activities prevent stress and stimulate mental health.", icon: "🐾" },
      { name: "Daily Updates", desc: "You receive regular updates on your pet's wellbeing and activities while boarding.", icon: "📱" },
    ],
    ctaBadge: "Pet Sanctuary Boarding",
    ctaTitle: "The Boarding",
    ctaItalic: "Experience.",
    ctaText: "Our veterinary boarding facility is one of Hyderabad's most trusted — offering premium care, professional supervision, and genuine love for every guest.",
    ctaBtn: "Reserve a Boarding Suite",
    seoText: "Premium pet boarding in Hyderabad. Veterinary supervised dog and cat boarding at Dr. Suresh Pet Care, Vanasthalipuram. Safe and comfortable pet boarding.",
    glowColor: "amber-500"
  };

  return (
    <>
      <SEO 
        title="Pet Boarding in Vanasthalipuram | Safe Stay"
        description="Safe and hygienic pet boarding with proper care and supervision for your pets while you travel. Our clinical environment ensures peace of mind."
        canonical="/boarding"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default BoardingPage;
